var chunkMapping = {
	"45": [
		2426
	],
	"724": [
		724
	],
	"814": [
		814
	],
	"939": [
		939
	],
	"985": [
		985
	],
	"1020": [
		1020
	],
	"1718": [
		1718
	],
	"1767": [
		1767
	],
	"1909": [
		1909
	],
	"2271": [
		2271
	],
	"2394": [
		2394
	],
	"3217": [
		3217
	],
	"3226": [
		3226
	],
	"3406": [
		3406
	],
	"3463": [
		3463
	],
	"3539": [
		3539
	],
	"4290": [
		4290
	],
	"5222": [
		5222
	],
	"5224": [
		5224
	],
	"5462": [
		5462
	],
	"5470": [
		5470
	],
	"5776": [
		5776
	],
	"6066": [
		6066
	],
	"6146": [
		6146
	],
	"6474": [
		6474
	],
	"6525": [
		6525
	],
	"6895": [
		6895
	],
	"6981": [
		6981
	],
	"7056": [
		7056
	],
	"7096": [
		7096
	],
	"7658": [
		7658
	],
	"7724": [
		7724
	],
	"8287": [
		8287
	],
	"8539": [
		8539
	],
	"9303": [
		9303
	]
};
var idToExternalAndNameMapping = {
	"724": [
		"default",
		"./style",
		3482
	],
	"814": [
		"default",
		"./translation",
		3482
	],
	"939": [
		"default",
		"./saga",
		2652
	],
	"985": [
		"default",
		"./reducer",
		1691
	],
	"1020": [
		"default",
		"./translation",
		2652
	],
	"1718": [
		"default",
		"./style",
		1691
	],
	"1767": [
		"default",
		"./reducer",
		3482
	],
	"1909": [
		"default",
		"./reducer",
		2652
	],
	"2271": [
		"default",
		"./reducer",
		7172
	],
	"2394": [
		"default",
		"./saga",
		7881
	],
	"2426": [
		"default",
		"./saga",
		3482
	],
	"3217": [
		"default",
		"./reducer",
		6554
	],
	"3226": [
		"default",
		"./reducer",
		2286
	],
	"3406": [
		"default",
		"./page",
		6554
	],
	"3463": [
		"default",
		"./saga",
		6554
	],
	"3539": [
		"default",
		"./page",
		7881
	],
	"4290": [
		"default",
		"./style",
		2286
	],
	"5222": [
		"default",
		"./translation",
		7172
	],
	"5224": [
		"default",
		"./translation",
		6554
	],
	"5462": [
		"default",
		"./page",
		1691
	],
	"5470": [
		"default",
		"./style",
		6554
	],
	"5776": [
		"default",
		"./page",
		3482
	],
	"6066": [
		"default",
		"./saga",
		2286
	],
	"6146": [
		"default",
		"./reducer",
		7881
	],
	"6474": [
		"default",
		"./style",
		2652
	],
	"6525": [
		"default",
		"./style",
		7881
	],
	"6895": [
		"default",
		"./translation",
		7881
	],
	"6981": [
		"default",
		"./saga",
		7172
	],
	"7056": [
		"default",
		"./translation",
		1691
	],
	"7096": [
		"default",
		"./page",
		7172
	],
	"7658": [
		"default",
		"./page",
		2652
	],
	"7724": [
		"default",
		"./style",
		7172
	],
	"8287": [
		"default",
		"./saga",
		1691
	],
	"8539": [
		"default",
		"./page",
		2286
	],
	"9303": [
		"default",
		"./translation",
		2286
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}